// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.content-wrapper {
  background: var(--ion-color-light);
  padding: 10px 6px 6px 6px;
  display: flex;
  flex-flow: column nowrap;
  height: 100%;
}

.header-row {
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
  align-items: center;
  margin-left: 10px;
  margin-right: 10px;
  padding-bottom: 4px;
  margin-bottom: 16px;
  border-bottom: 1px solid var(--ion-color-medium);
}
.header-row .title {
  display: flex;
  align-items: center;
  color: var(--ion-color-dark);
}
.header-row .title ion-label {
  padding-left: 8px;
  font-size: 16px;
  font-weight: 500;
  cursor: default;
}

.window-content {
  flex-grow: 1 !important;
  padding-left: 10px;
  padding-right: 4px;
  overflow-y: scroll;
}

.bottom-section {
  flex-grow: 0;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin: 1rem 0.5rem 0.5rem 0.5rem;
}
.bottom-section ion-button {
  height: 32px;
  margin-left: 16px;
  --background-hover: var(--ion-color-dark);
  --background-hover-opacity: 1;
  text-transform: none;
  --padding-start: 16px;
  --padding-end: 16px;
  --border-radius: 8px 8px 8px 8px;
}
.bottom-section ion-button fa-icon {
  font-size: 16px;
  padding-right: 8px;
}

.custom-button {
  font-size: 14px;
}

/* for Chrome, Safari, and Opera */
.window-content::-webkit-scrollbar {
  width: 6px;
}

.window-content::-webkit-scrollbar-track {
  background: transparent;
}

.window-content::-webkit-scrollbar-track:hover {
  background: transparent;
}

.window-content::-webkit-scrollbar-thumb {
  background: #a1a1a1;
  border-radius: 6px;
}

.window-content::-webkit-scrollbar-thumb:hover {
  background: #8e8e8e;
}

.window-content.inner-scroll {
  scrollbar-width: thin;
}`, "",{"version":3,"sources":["webpack://./src/app/shared-components/content-tree-modal/modal-tree.component.scss"],"names":[],"mappings":"AAAA;EACE,kCAAA;EACA,yBAAA;EACA,aAAA;EACA,wBAAA;EACA,YAAA;AACF;;AAEA;EACE,aAAA;EACA,qBAAA;EACA,8BAAA;EACA,mBAAA;EACA,iBAAA;EACA,kBAAA;EACA,mBAAA;EACA,mBAAA;EACA,gDAAA;AACF;AAAE;EACE,aAAA;EACA,mBAAA;EACA,4BAAA;AAEJ;AADI;EACE,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;AAGN;;AAEA;EACE,uBAAA;EACA,kBAAA;EACA,kBAAA;EACA,kBAAA;AACF;;AAEA;EACE,YAAA;EACA,aAAA;EACA,yBAAA;EACA,mBAAA;EACA,iCAAA;AACF;AAAE;EACE,YAAA;EACA,iBAAA;EACA,yCAAA;EACA,6BAAA;EACA,oBAAA;EACA,qBAAA;EACA,mBAAA;EACA,gCAAA;AAEJ;AADI;EACE,eAAA;EACA,kBAAA;AAGN;;AAEA;EACE,eAAA;AACF;;AAEA,kCAAA;AACA;EACE,UAAA;AACF;;AACA;EACE,uBAAA;AAEF;;AAAA;EACE,uBAAA;AAGF;;AADA;EACE,mBAAA;EACA,kBAAA;AAIF;;AAFA;EACE,mBAAA;AAKF;;AAHA;EACE,qBAAA;AAMF","sourcesContent":[".content-wrapper {\n  background: var(--ion-color-light);\n  padding: 10px 6px 6px 6px;\n  display: flex;\n  flex-flow: column nowrap;\n  height: 100%;\n}\n\n.header-row {\n  display: flex;\n  flex-flow: row nowrap;\n  justify-content: space-between;\n  align-items: center;\n  margin-left: 10px;\n  margin-right: 10px;\n  padding-bottom: 4px;\n  margin-bottom: 16px;\n  border-bottom: 1px solid var(--ion-color-medium);\n  .title {\n    display: flex;\n    align-items: center;\n    color: var(--ion-color-dark);\n    ion-label {\n      padding-left: 8px;\n      font-size: 16px;\n      font-weight: 500;\n      cursor: default;\n    }\n  }\n}\n\n.window-content {\n  flex-grow: 1 !important;\n  padding-left: 10px;\n  padding-right: 4px;\n  overflow-y: scroll;\n}\n\n.bottom-section {\n  flex-grow: 0;\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n  margin: 1rem 0.5rem 0.5rem 0.5rem;\n  ion-button {\n    height: 32px;\n    margin-left: 16px;\n    --background-hover: var(--ion-color-dark);\n    --background-hover-opacity: 1;\n    text-transform: none;\n    --padding-start: 16px;\n    --padding-end: 16px;\n    --border-radius: 8px 8px 8px 8px;\n    fa-icon {\n      font-size: 16px;\n      padding-right: 8px;\n    }\n  }\n}\n\n.custom-button {\n  font-size: 14px;\n}\n\n/* for Chrome, Safari, and Opera */\n.window-content::-webkit-scrollbar {\n  width: 6px;\n}\n.window-content::-webkit-scrollbar-track {\n  background: transparent;\n}\n.window-content::-webkit-scrollbar-track:hover {\n  background: transparent;\n}\n.window-content::-webkit-scrollbar-thumb {\n  background: #a1a1a1;\n  border-radius: 6px;\n}\n.window-content::-webkit-scrollbar-thumb:hover {\n  background: #8e8e8e;\n}\n.window-content.inner-scroll {\n  scrollbar-width: thin;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
